import Service from "../Service";

import Vue from "vue";

export default {

    getUrlSearchConceptService() {
        return Vue.prototype.$http.defaults.baseURL + "GenConceptService/list";
    },
};